<template>
    <div>
        <button class="ds-btn ds-btn--success mr-1" @click="isModalVisible = true" v-b-tooltip.hover title="Kategorijas dokumenti">
            <font-awesome-icon icon="file-pdf"/>
        </button>
        <b-modal v-model="isModalVisible" @show="setSelectedCategoryId(categoryId)" @hidden="resetDocuments" no-close-on-backdrop hide-footer body-class="p-2"
                 header-class="bg-light align-items-center" size="xl">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">Kategorijas dokumenti</h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <button @click="addNewDocumentEntry" class="ds-btn ds-btn--default ml-2 mb-2" v-b-tooltip.hover title="Pievienot jaunu dokumentu sarakstā">
                <font-awesome-icon icon="plus"/>
            </button>
            <DocumentsBaseForm v-for="document in documents"
                               :ref-id="`form-${document._id}`"
                               :key="`document-${document._id}`"
                               :document-data="document"
                               @finished="resetDocuments"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapMutations} from 'vuex';
    import _ from 'lodash';

    import DocumentsBaseForm from './DocumentsBaseForm';
    import {Document} from '../../vuex/modules/document/models/document.models';
    import * as documentStoreTypes from '../../vuex/modules/document/document.store-types';

    export default {
        name: 'documents-manage',
        components: {DocumentsBaseForm},
        props: {
            documentsData: {
                type: Array,
                required: true,
            },
            categoryId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isModalVisible: false,
                documents: _.cloneDeep(this.documentsData),
            }
        },
        methods: {
            ...mapMutations('document', {
                /** @type {function|*} */
                setSelectedCategoryId: documentStoreTypes.SET_SELECTED_CATEGORY_ID,
            }),
            resetDocuments() {
                this.documents = _.cloneDeep(this.documentsData);
            },
            addNewDocumentEntry() {
                this.documents.unshift(Document.fromArray({}));
            },
        }
    }
</script>